import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import Spinner from '@goeuro/app/client/frontend-components/src/Spinner';

import Home from 'views/home';

const Imprint = React.lazy(() => import('views/imprint'));
const TermsOfUse = React.lazy(() => import('views/terms-of-use'));
const PrivacyPolicy = React.lazy(() => import('views/privacy-policy'));

const AppRoutes = ({
  translations,
}: {
  translations: Record<string, string>;
}) => (
  <React.Suspense fallback={<Spinner />}>
    <Switch>
      <Route path="/" exact>
        <Home translations={translations} />
      </Route>
      <Route path="/legal" component={Imprint} />
      <Route path="/terms-of-use" component={TermsOfUse} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
    </Switch>
  </React.Suspense>
);

AppRoutes.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string),
};

export default AppRoutes;
